<div class="sub-menu-root-container employee-menu-root-container"
    [style.width]="show ? 'var(--left-side-optionbar-width)' : '25px'">
    <div class="menu-list-container">
        <!-- Masters List -->

        <!-- <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('employee')" class="mat-list-item"
            routerLink="/employee/employee-category" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Category' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/employee-category.svg">
                <span class="master-title" style="word-wrap: break-word;">Category
                </span>
            </div>
        </mat-list-item> -->

        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('employee')" class="mat-list-item"
            routerLink="/employee/employee-job-position" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Job Position' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <mat-icon class="menu-icon" style="overflow: unset; margin: unset;">category</mat-icon>
                <span class="master-title" style="word-wrap: break-word;">Job Position
                </span>
            </div>
        </mat-list-item>

        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('employee')" class="mat-list-item"
            routerLink="/employee/employee-job-title" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Job Title' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <mat-icon class="menu-icon" style="overflow: unset;margin: unset;">badge</mat-icon>
                <span class="master-title" style="word-wrap: break-word;">Job Title
                </span>
            </div>
        </mat-list-item>

        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('employee')" class="mat-list-item"
            routerLink="/employee/employee-status" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Status' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <mat-icon class="menu-icon" style="overflow: unset; margin: unset;">settings_accessibility</mat-icon>
                <span class="master-title" style="word-wrap: break-word;">Status
                </span>
            </div>
        </mat-list-item>
        <!-- Old link:
        <mat-list-item class="mat-list-item" *ngIf="userData?.user_type !== 'HQ' && hasAccess('employee')"
            routerLink="/employee/employee" [routerLinkActive]="['is-active']" [matTooltip]="!show ? 'Employee' : ''"
            matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/employees.svg">
                <span class="master-title">Employee</span>
            </div>
        </mat-list-item>
        -->
        <mat-list-item class="mat-list-item" *ngIf="userData?.user_type !== 'HQ' && hasAccess('employee')"
            routerLink="/employee/employee-ext" [routerLinkActive]="['is-active']" [matTooltip]="!show ? 'Employee' : ''"
            matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/employees.svg">
                <span class="master-title">Employee</span>
            </div>
        </mat-list-item>

        <mat-list-item class="mat-list-item" *ngIf="userData?.user_type === 'HQ' && hasAccess('employee')"
            routerLink="/employee/employee-ext" [routerLinkActive]="['is-active']"
            [matTooltip]="!show ? 'Employee' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/employees.svg">
                <span class="master-title">Employee</span>
            </div>
        </mat-list-item>
        <mat-list-item class="mat-list-item" *ngIf="userData?.user_type === 'SHOP' && hasAccess('staff-attendance')"
            routerLink="/employee/staff-attendance" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Staff Attendance' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/attendence-export.svg">
                <span class="master-title">Staff Attendance
                </span>
            </div>
        </mat-list-item>



    </div>
</div>